import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_STATUSPEND] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.statusPend = payload
  },
  [types.SET_STATUSPENDS] (state, payload) {
    state.statusPends = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  }
}
